import React, { useState } from "react";
import classes from "./docsForSigning.module.css";
import { DocumentItemDownloadUI } from "../../../Ui/DocumentItems/DocumentItemDownload/DocumentItemDownloadUI";
import { IDocksForSigningProps } from "../../../../interfaces/props/IDocksForSigningProps";
import { DOCUMENT_DOWNLOAD_SIGNIN_STATUS_ENUM } from "../../../../enums/documentDownloadSigningStatusEnum";
import { IDownloadDocumentHandlerProps } from "../../../../interfaces/props/IDownloadDocumentHandlerProps";

export const DocsForSigning = (props: IDocksForSigningProps) => {
  const { docs } = props;
  const [title, _] = useState('Документы для подписания');

  const download = ({ name, document_id, applicationBankId }: IDownloadDocumentHandlerProps) => {
    props.download!({ name, document_id, applicationBankId });
  };

  const renderList= () => {
    return docs?.map(el => {
      const { id, name, type_doc, sign_file, application_banks_id } = el;
      
      const status = sign_file && sign_file.length ? DOCUMENT_DOWNLOAD_SIGNIN_STATUS_ENUM.SIGNED : DOCUMENT_DOWNLOAD_SIGNIN_STATUS_ENUM.NOT_SIGNED;
      
      return (
        <DocumentItemDownloadUI
          key={ id }
          className={classes.docsForSigning_documentItem}
          title={type_doc.name}
          subtitle={name}
          signingStatus={status}
          downloadButtonProps={undefined}
          onDownload={() => download({name, document_id: id, applicationBankId: application_banks_id})}
          hideSigningStatus={false}
        />
      )
    })
  };

  return (
    <>
      <p className={classes.docsForSigning_header}>
        {title}
      </p>

      <div className={classes.docsForSigning_documentList}>
        { renderList() }
      </div>
    </>
  );
};
